export enum ProductVersionStatus {
    Draft = 'Draft',
    Released = 'Released',
    Obsolete = 'Obsolete'
}